import React from 'react';
import PropTypes from 'prop-types';
import { COUNTRIES } from '../../../helpers/locationAbbrevHelper';

export default class Countries extends React.PureComponent {
    constructor() {
        super();
        this.getCountries = this.getCountries.bind(this);
    }
    getCountries(){
        const countryOptions = [];
        COUNTRIES.map((value) => {
            const key = `state-${value.value}`;
            const r = (
                <option value={value.value} key={key}>
                    {value.label}
                </option>
            );
            return countryOptions.push(r);
        });
        return countryOptions;
    }
    render() {
        return (
            <select
                id="country"
                name="country"
                className={this.props.className}
                defaultValue={this.props.account.home_address.country || ''}
                onChange={this.props.handleChange}>
                {this.getCountries()}
            </select>
        );
    }
}

Countries.propTypes = {
    className: PropTypes.string,
    account: PropTypes.shape({
        account_id: PropTypes.string,
        first_name: PropTypes.string,
        home_address: PropTypes.shape({
            address1: PropTypes.string,
            address2: PropTypes.string,
            city: PropTypes.string,
            country: PropTypes.string,
            state: PropTypes.string,
            zip_code: PropTypes.string
        }),
        home_phone: PropTypes.string,
        last_name: PropTypes.string
    }).isRequired,
    handleChange: PropTypes.func
};

